import {
  LOAD_MENU,
  LOAD_MENU_ERROR,
  LOAD_MENU_SUCCESS,
  LOAD_OPERATIONS,
  LOAD_OPERATIONS_ERROR,
  LOAD_OPERATIONS_SUCCESS,
  UPDATE_OPERATIONS_FILTERS,
  SET_OPERATIONS_PAGE_SELECTED
} from '../constants/operations';

const initialState = {
  menu: [],
  menuLoading: false,
  menuLoadingError: false,
  operations: [],
  operationsLoading: false,
  operationsLoadingError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_OPERATIONS_FILTERS:
      return {
        ...state,
        operationsLoading: true,
      };

    case LOAD_MENU:
      return {
        ...state,
        menuLoading: true,
      };

    case LOAD_MENU_ERROR:
      return {
        ...state,
        menuLoading: false,
        menuLoadingError: true,
      };

    case LOAD_MENU_SUCCESS:
      return {
        ...state,
        menuLoading: false,
        menuLoadingError: false,
        menu: action?.menus || state?.menu || [],
      };

    case LOAD_OPERATIONS:
      return {
        ...state,
        operationsLoading: true,
      };

    case LOAD_OPERATIONS_ERROR:
      return {
        ...state,
        operationsLoading: false,
        operationsLoadingError: true,
      };

    case LOAD_OPERATIONS_SUCCESS:
      return {
        ...state,
        operationsLoading: false,
        operationsLoadingError: false,
        operations: action.operations || [],
        menu: action?.menu || state?.menu || [],
      };

    case SET_OPERATIONS_PAGE_SELECTED:
      return {
        ...state,
        operations: state.operations.map(operation => ({
          ...operation,
          selected: operation.id === action.pageId
        })),
      };

    default:
      return state;
  }
};
